import React from 'react'
// libs
import { useDispatch, useSelector } from 'react-redux'
import { arrayRemoveAll, formValueSelector } from 'redux-form'
// hooks
import { useApolloClient } from 'hooks/useApolloClient'
// components
import MappedProperties from 'components/Modals/SystemProcessModal/Form/components/Transactions/components/Transaction/components/MappedProperties'
import RelatedFormsSelect from 'components/Modals/SystemProcessModal/Form/components/Transactions/components/Transaction/components/RelatedFormsSelect'
// graphql
import { RISK_TEMPLATE_QUERY } from 'graphql/risk/queries'
// constants
import { Forms } from 'constants/index'
// views
import { Wrapper } from './views'
// utils
import get from 'lodash/get'
import { handleError } from 'utils/errors/handlers'

interface Props {
  field: string
}

const selector = formValueSelector(Forms.SYSTEM_PROCESS_CREATE_FORM)

const CreateRelatedForm: React.FC<Props> = ({ field }) => {
  const dispatch = useDispatch()

  const { client } = useApolloClient()

  const riskTemplateId = useSelector((state) => selector(state, `${field}.riskTemplateId`))?.value

  const [fields, setFields] = React.useState([])

  const getRiskTemplateFields = async (id: string) => {
    try {
      const riskTemplateFields = get(
        await client.query({
          fetchPolicy: 'no-cache',
          query: RISK_TEMPLATE_QUERY,
          variables: { filter: { ids: [id] }, pagination: { pageTake: 1, pageSkip: 0 } }
        }),
        'data.riskTemplates.data[0].fields'
      )

      setFields(riskTemplateFields)
    } catch (e) {
      handleError(e, 'Schedule.getRiskTemplateFields')
    }
  }

  const onFormChange = () => {
    dispatch(arrayRemoveAll(Forms.SYSTEM_PROCESS_CREATE_FORM, `${field}.fieldValues`))
  }

  React.useEffect(() => {
    if (riskTemplateId) {
      getRiskTemplateFields(riskTemplateId)
    }
  }, [riskTemplateId])

  return (
    <Wrapper>
      <RelatedFormsSelect field={field} onChange={onFormChange} />
      <MappedProperties fields={fields} dueDateNowOnly name={`${field}.fieldValues`} />
    </Wrapper>
  )
}

export default CreateRelatedForm
